import { createActionConst } from '../../../utils/action.utils';

const ANNUALS_NAMESPACE = 'ANNUALS';

export const CREATE_ANNUAL = createActionConst(ANNUALS_NAMESPACE, 'CREATE_ANNUAL');
export const UPDATE_ANNUAL = createActionConst(ANNUALS_NAMESPACE, 'UPDATE_ANNUAL');
export const DELETE_ANNUAL = createActionConst(ANNUALS_NAMESPACE, 'DELETE_ANNUAL');
